import React from 'react';
import { SortDirection } from '@tanstack/react-table';
import { ChevroneIcon } from '../../common/chevroneIcon';

type Props = {
    isSorted: false | SortDirection;
    color?: string;
};

export const SortingChevrone = ({
    isSorted,
    color,
}: Props): JSX.Element | null => {
    if (!isSorted) {
        return null;
    }
    if (isSorted === 'asc') {
        return <ChevroneIcon direction="up" style={{ color }} />;
    }
    return <ChevroneIcon direction="down" style={{ color }} />;
};
